import "./Heading.css";

const Heading = ({ className, text }) => {
  return <h2 className={className}>{text}</h2>;
};
export default Heading;
